<template>
  <q-dialog v-model="logout" persistent>
    <q-card square>
      <div class="logout-text">
        {{ message }}
      </div>
      <div class="logout-actions">
        <div class="cancel-button" v-if="!unauth" @click="logout = false">
          Cancel
        </div>
        <div class="logout-button" @click="sure">
          {{ !unauth ? "Logout" : "Redirect to Login" }} 
          <span v-if="unauth">({{ counter }})</span>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from "../axios";
import modules from "../store/modules";
export default {
  data() {
    return {
      counter: 3,
      polling: null,
    };
  },
  computed: {
    unauth() {
      return this.$store.state.layout.unauth;
    },
    logout: {
      get() {
        return this.$store.state.layout.logout;
      },
      set(val) {
        this.$store.commit("layout/SET_LOGOUT", val);
      },
    },
    message() {
      return this.$store.state.layout.message;
    },
  },
  methods: {
    sure() {
      for (const name of Object.keys(modules)) {
        this.$store.commit(`${name}/resetState`, true);
      }
      localStorage.removeItem("token");
      this.$router.push({ name: "login" });
      delete axios.defaults.headers.common["Authorization"];
    },
  },
  watch: {
    unauth(n, o) {
      if (n) {
        this.polling = setInterval(() => {
          this.counter -= 1;
        }, 1000);
        setTimeout(() => {
          this.sure();
        }, 3000);
      } else {
        clearInterval(this.polling);
      }
    },
  },
  destroyed(){
    clearInterval(this.polling)
  }
};
</script>

<style lang="scss">
.logout-button {
  background: #1976d2;
  border-radius: 5px;
  color: #fff;
}
.cancel-button {
  background: #bdbdbd;
  border-radius: 5px;
  color: #fff;
}
.logout-text {
  border-bottom: 1px solid #ccc;
  padding: 15px;
  font-weight: 700;
}
.logout-actions {
  display: flex;
  padding: 10px 15px;
  align-items: center;
  justify-content: flex-end;
  div {
    margin-left: 5px;
    padding: 5px;
    cursor: pointer;
  }
}
</style>